module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Semibold.36c62e8c0c2b47312314ec21d4178f42.woff";